import companyPaymentService from './companyPaymentService'

export default companyPaymentService
